import "../../App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import Nopage from "../Nopage/Nopage";
import UserPagesLayout from "./Layout/Layout";
import UserHomePage from "./UserHome/UserHomePage";
import ScrollToTop from "../../utils/scrollToTop";
import NotificationsPage from "./Notifications/Notifications";
import { IAuthType } from "../../apiservice/authService.type";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import { useEffect } from "react";
import UserLogout from "./UserProfile/UserLogout";
import UserChangePasswordPage from "./UserProfile/UserChangePassword";
import UserGettingStartedPage from "./UserProfile/UserGettingStarted";
import UserHelpCenterPage from "./UserProfile/UserHelpCenter";
import UserManageProfilePage from "./UserProfile/UserManageProfile";
import UserProfilePage from "./UserProfile/UserProfile";
import UserTransactionPages from "./UserProfile/UserTransactions";
import UserTransactionsDetailsPage from "./UserProfile/UserTransactionsDetails";
import UserLibraryPage from "./UserHome/UserLibraryPage";
import UserSearchPage from "./UserHome/UserSearchPage";
import UserBooksDetailsPage from "./UserHome/UserBooksDetailsPage";
import UserBooksAudioPage from "./UserHome/UserBooksAudioPage";
import UserBooksListPage from "./UserHome/UserBooksListPage";
import UserCategoryListPage from "./UserHome/UserCategoryListPage";
import UserSubscriptionPage from "./UserProfile/UserSubscription";
import TagSearchPage from "../../components/BookComponents/TagSearch";
import UserTagSearchPage from "./UserHome/UserTagSearchPage";
import UserPreferencePage from "./UserHome/UserPreferencePage";
import UserPreferencePageTag from "./UserHome/UserPreferencePageTag";
import UserPreferencePageCategory from "./UserHome/UserPreferencePageCategory";
import UserSubscriptionPaymentPage from "./UserProfile/UserSubscriptionPayment";
import UserShortsPage from "./UserHome/UserShortsPage";
import UserBooksCollectionsListPage from "./UserHome/UserBooksCollectionsListPage";

const UserDashboardPagesRoute = () => {
  const scrollToTop = ScrollToTop();

  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.data?.credentials?.signupStatusId === 1) {
      navigate("/auth/verify-email");
    }
  }, [authData]);

  return (
    <Routes>
      <Route path="/" element={<UserPagesLayout />}>
        <Route index element={<UserHomePage />} />

        <Route path="/home" element={<UserHomePage />} />
        <Route path="/library" element={<UserLibraryPage />} />
        <Route path="/search" element={<UserSearchPage />} />
        <Route path="/shorts" element={<UserShortsPage />} />
        <Route path="/profile" element={<UserProfilePage />} />

        <Route path="/category-list" element={<UserCategoryListPage />} />
        <Route path="/book-list" element={<UserBooksListPage />} />
         <Route path="/book-collections-list/:groupId/:groupName" element={<UserBooksCollectionsListPage />} />
        <Route
          path="/book-list/:categoryId/:categoryName"
          element={<UserBooksListPage />}
        />
        <Route
          path="/book-details/:id/:BookName"
          element={<UserBooksDetailsPage />}
        />
        <Route
          path="/book-details-audio/:id/:BookName"
          element={<UserBooksAudioPage />}
        />
        <Route path="/tag-search" element={<UserTagSearchPage />} />
        <Route path="/preference" element={<UserPreferencePage />} />
        <Route path="/preference-tag" element={<UserPreferencePageTag />} />
        <Route
          path="/preference-category"
          element={<UserPreferencePageCategory />}
        />

        <Route path="/notification" element={<NotificationsPage />} />

        <Route path="/editprofile" element={<UserManageProfilePage />} />
        <Route path="/change-password" element={<UserChangePasswordPage />} />
        <Route path="/subscription" element={<UserSubscriptionPage />} />
        <Route
          path="/subscription-payment"
          element={<UserSubscriptionPaymentPage />}
        />
        <Route path="/transactions" element={<UserTransactionPages />} />
        <Route
          path="/transactions/:id"
          element={<UserTransactionsDetailsPage />}
        />
        <Route path="/getStarted" element={<UserGettingStartedPage />} />
        <Route path="/helpcenter" element={<UserHelpCenterPage />} />
        <Route path="/logout" element={<UserLogout />} />
        <Route path="*" element={<Nopage />} />
      </Route>
    </Routes>
  );
};

export default UserDashboardPagesRoute;
